import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import type { ProfileLink } from "../data/profile";
import { useMemberProfile } from "../MemberProfileContext";
import { OwnedField } from "./FormFields";
import { FormShell } from "./ProfileOverlayShell";

const linkFormSchema = z.object({
    title: z.string().trim().min(3, "Enter at least 3 characters"),
    url: z.url("Enter a valid URL"),
});

type LinkFormValues = z.infer<typeof linkFormSchema>;

export function LinkForm({
    link,
    onClose,
}: {
    link?: ProfileLink;
    onClose: () => void;
}) {
    const { createLink, updateLink } = useMemberProfile();
    const { control, handleSubmit } = useForm<LinkFormValues>({
        resolver: zodResolver(linkFormSchema),
        defaultValues: {
            title: link?.title ?? "",
            url: link?.url ?? "",
        },
    });

    function onSubmit(values: LinkFormValues) {
        if (link) {
            updateLink(link.id, values, onClose);
            return;
        }

        createLink(values, onClose);
    }

    return (
        <FormShell
            title={link ? "Edit link" : "Add link"}
            onClose={onClose}
            onSave={handleSubmit(onSubmit)}
        >
            <OwnedField
                id="link-title"
                label="Title"
                kind="text"
                control={control}
                name="title"
                required
            />
            <OwnedField
                id="link-url"
                label="URL"
                kind="text"
                control={control}
                name="url"
                required
            />
        </FormShell>
    );
}
